export default __webpack_public_path__ + "static/media/partners_1500.d0edb41c.jpeg";